import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { projectContract } from 'shared/domain/project/projectContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastProjectError = makeErrorPublisher(projectContract);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedProjectError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedProjectError', error, messageId, uniqueId);
  broadcastProjectError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
